export function parseDatasourceUrl(schema: string):
  | {
      url: string;
    }
  | {
      env: string;
    } {
  /**
   * ASSUMPTIONS
   * 1. There will only be one place where `url = ` can appear: inside `datasource`s
   * 2. There will only be one `datasource` block
   */

  /**
   * 1. Ignores all whitespace.
   * 2. Matches all lines that begin with `url =`
   * 3. Does not match lines that are commented out
   * 4. Uses a capture group to check if the `datasource.url` uses an env var
   * 5. Uses a capture group to extract characters between "" inside `datasource.url` (may be an env var or not)
   */
  const matches = schema.match(
    /^(?!(\s+\/\/\s+))\s+url\s+\=\s+(?<usesEnv>env\()?\"(?<url>.*)\"/im
  );
  const { usesEnv, url } = matches?.groups as {
    usesEnv?: string;
    url?: string;
  };

  if (usesEnv) {
    return {
      env: url!,
    };
  }

  return { url: url! };
}
